import React from 'react';
import moment from "moment";
import Snackbar from '@mui/material/Snackbar';
import {Typography, Box} from '@mui/material';
import rightTick from '../../assets/img/rightTick.png';
import {isEmpty} from "../../utils/validations";

let s3BaseURL = process.env.REACT_APP_S3_PUBLIC_BASE_IMAGE_URL;

const PublicationsView = (props) => {
    const {isMobileView, publications, open, vertical, horizontal, handleClose, copyToClipboard} = props;
    const publicationsRecord = isEmpty(publications) ? [] : publications.slice(0, 3);

    return (
        <div className="col-lg-4 col-md-12">
            <div className="knowledge-bank-sub-container">
                <div className="knowledge-bank-header-box">
                    <h3 className="knowledge-bank-sub-container-header">Publications</h3>
                    <div className={isMobileView ? "d-none" : "d-block"}>
                        <a href="/knowledge-bank/publications">
                            <button className="btn btn-outline-dark ">
                                Read More
                            </button>
                        </a>
                    </div>
                </div>

                {publicationsRecord.map((e, index) =>
                    <div className="d-flex pb-5" key={index}>
                        <div className="img-blog">
                            <iframe width={isMobileView ? "115" : "161"}
                                    frameBorder="0" allowFullScreen=""
                                    className="blog_img"
                                    height={"100%"}
                                    style={{aspectRatio: 16 / 9}}
                                    src={s3BaseURL + e.image}
                            />
                        </div>
                        <div className="text-start w-100 ps-3">
                            <a href={s3BaseURL + e.image}
                               className="blog-text cursor blog-text-truncate"
                               target={"_blank"}>
                                {e.title}
                            </a>
                            <div className="date-container mt-1 d-flex justify-content-between align-items-center">
                                <div>
                                    <i className="fa-regular fa-calendar"/>
                                    &nbsp;
                                    {moment(e.date).format("MMM D, YYYY")}
                                </div>
                                <i className="fa-regular fa-copy cursor"
                                   onClick={() => copyToClipboard(s3BaseURL + e.image)}
                                />
                            </div>
                        </div>
                    </div>
                )}

                {isMobileView ?
                    <div className="text-center mt-5">
                        <a href="/knowledge-bank/publications">
                            <button className="btn btn-outline-dark ">
                                Read More
                            </button>
                        </a>
                    </div> : ''
                }
            </div>

            <Snackbar
                anchorOrigin={{vertical, horizontal}}
                autoHideDuration={2000}
                open={open}
                onClose={handleClose}
                message={<Box display="flex" alignItems="center">
                    <img src={rightTick} alt="Right Tick" style={{marginRight: 10, width: 25, height: 20}}/>
                    <Typography sx={{color: 'white', fontSize: 18, fontFamily: 'Poppins'}}>Link Copied!</Typography>
                </Box>
                }
                sx={{
                    '& .MuiSnackbarContent-root': {
                        backgroundColor: '#51A351',
                        width: '330px',
                    }
                }}
                key={vertical + horizontal}
            />
        </div>
    );
};

export default PublicationsView;